<template>
  <div class="d-flex" style="min-height: 45vw;">
    <div class="content p-4 w-100">
      <div class="d-flex">
        <h4 class="card-title mt-0">{{ title }}</h4>
      </div>
      <div class="row">
        <div class="col-3 mt-2">
          <v-select
            class="small mt-2"
            v-model="form.format"
            :items="formats"
            :label="i18n.global.t('pages.downloadData.format')"
            :clearable="false"
          >
          </v-select>
        </div>
        <div
          class="col-3 mt-2"
        >
          <SingleOperationOfficeAutoComplete
            v-model="form.operationOffice"
            class="mt-2"
            :selectFirstIfOnlyOne="true"
            :clearable="false"
            :error-messages="errors.operationOffice"
          />
        </div>
        <div class="col-4">
          <span class="small">
            {{ i18n.global.t('pages.downloadData.range') }}
          </span>
          <RangeDatePicker
            v-model="form.selectDateRange"
            :maxRange="30"
            format="yyyy/MM/dd"
          />
        </div>
      </div>
      <div class="d-flex justify-content-end mt-3">
        <v-btn
          class="exec-btn"
          @click="handleClickOutputPdf"
          :style="{
            backgroundColor : downloading ? '#B3B8BB' : ''
          }"
        >
        {{downloadBtnLabel}}
        </v-btn>
      </div>
    </div>
  </div>
  <GDialog
    v-model="dialogState"
    max-width="30%"
    transition="custom-from-bottom-transition"
  >
    <div class="modal-header justify-content-center pt-3">
      <label>
        {{ i18n.global.t('pages.downloadData.completedReception') }}
      </label>
    </div>
    <div class="row mt-2 mr-3 ml-3 pl-5 v-theme--light">
      {{ i18n.global.t('pages.downloadData.messages.acceptedDownload') }}
      <br />
      {{ i18n.global.t('pages.downloadData.messages.outputCompletedAfterEmailNotification') }}
    </div>
    <div class="d-flex justify-content-end m-3">
      <v-btn class="m-1 reset-btn" @click="closeModal">
        {{ i18n.global.t('pages.common.button.close') }}
      </v-btn>
    </div>
  </GDialog>
</template>

<script>
  import Api from "@/services/api/ApiServiceFabrick";
  import { GDialog } from 'gitart-vue-dialog'
  import {
    DOWNLOAD_DATA_FORMATS,
    DEPARTMENT_OFFICE_TYPE,
    DOWNLOAD_DATA_REMOVED_FORMATS
  } from '@/services/consts'
  import { formatDate } from '@/services/functions';
  import selectRoleChecker from "@/router/selectRoleChecker";
  import RangeDatePicker from '@/components/Common/RangeDatePicker.vue';
  import SingleOperationOfficeAutoComplete from '@/components/AutoCompletes/SingleOperationOfficeAutoComplete.vue';
  import i18n from '@/lang/i18n';

  export default {
    setup() {
      return {
        i18n,
      }
    },
    data() {
      return {
        title: i18n.global.t('pages.downloadData.title.downloadData'),
        form: {
          format: "logi_attendance",
          operationOffice: null,
          selectDateRange: [new Date(), new Date()],
        },
        formats: [],
        account: null,
        dialogState: false,
        downloading: false,
        errors: {},
      }
    },
    mounted() {
      document.title = this.title;
      this.form.selectYearMonth = this.getThisYearMoth()
      this.getAccount()
      this.formats = this.downloadDataList()
    },
    computed: {
      downloadBtnLabel() {
        return this.downloading ?
          i18n.global.t('common.downloadingBtn') :
          i18n.global.t('common.downloadBtn')
      }
    },
    methods: {
      handleClickOutputPdf() {
        if (!this.isValid()) return
        this.downloading = true
        const params = this.makeCreateFileRequest()
        Api().createDownloadData(params).then(() => {
          this.dialogState = true
          this.downloading = false
        }).catch((error) => {
          const res = error.response
          switch (res.status) {
            case 401:
              this.loginWithRedirect({ appState: { targetUrl: location.pathname } })
              break
            case 403:
              location.reload()
              break
            case 422:
          }
          this.downloading = false
        })
      },
      makeCreateFileRequest() {
        const type = this.form?.format;

        const startDate = this.form.selectDateRange[0];
        const endDate = this.form.selectDateRange[1] ?? new Date(startDate.getTime());
        const operationOfficeId = this.setOperationOfficeId()

        const params = {
          type: type,
          operation_office_id: operationOfficeId,
          start_date: formatDate(startDate),
          end_date: formatDate(endDate),
        }
        return params
      },
      setOperationOfficeId() {
        if (this.account.login_department_type == DEPARTMENT_OFFICE_TYPE) {
          const role = selectRoleChecker.getCurrentRole();
          return role?.organization?.operation_office_id;
        }

        return this.form.operationOffice?.id
      },
      getThisYearMoth() {
        const today = new Date()
        return { year: today.getFullYear(), month: today.getMonth() }
      },
      getAccount() {
        Api().getSelfAccount().then((data) => {
          this.account = data
        })
      },
      closeModal() {
        this.dialogState = false
      },
      isValid() {
        this.errors = {}
        if (!this.form.operationOffice) {
          this.errors.operationOffice = this.$t("pages.downloadData.messages.operationOfficeRequired")
          return false
        }
        return true
      },
      downloadDataList() {
        return DOWNLOAD_DATA_FORMATS.filter((v) => {
          if (!DOWNLOAD_DATA_REMOVED_FORMATS.includes(v.value)) {
            return v
          }
        })
      }
    },
    components: {
      RangeDatePicker,
      GDialog,
      SingleOperationOfficeAutoComplete,
    }
  }
</script>

<style>
.dp__button_bottom {
  display: none;
}
</style>
